import { API_BASE_URL } from '@/config'
import ApiPath from '@/serves/path'
import { SpeechError, SpeechErrorCode } from './errors'
import { fetchWithTimeout } from './utils'

/**
 * 上传整段录音，沿用项目原有的上传接口（后端落 S3，返回可回放的 mp3 地址）。
 *
 * 这个接口和以前一样不带登录态、直连 API_BASE_URL（不走 dev 代理），
 * 表单字段名也保持不变：speech / sid / sound_xml。sound_xml 原先存讯飞的 XML，
 * 现在存厂商的原始 JSON，后端只是原样落文件。
 *
 * @param {Blob} wav 整段录音
 * @param {string|number} [sid] 会话标识，缺省用时间戳
 * @param {string} [resultJson] 厂商原始结果，随录音一起存档
 * @returns {Promise<{mp3Url: string, xmlUrl: string}>}
 * @throws {SpeechError} NETWORK / BAD_RESPONSE
 */
export async function uploadRecording(wav, { sid, resultJson } = {}) {
  const fd = new FormData()
  fd.append('speech', wav, 'record.wav')
  fd.append('sid', String(sid || Date.now()))
  fd.append('sound_xml', resultJson || '')

  // 不手设 Content-Type，交给浏览器带 multipart boundary
  const { res, parsed } = await fetchWithTimeout(
    API_BASE_URL + ApiPath.speech_upload_audio,
    { method: 'POST', body: fd, headers: { Accept: 'application/json' } },
    60000
  )
  const body = parsed.json
  if (!res.ok || !body || body.errcode !== 0 || !body.data) {
    throw new SpeechError(
      SpeechErrorCode.BAD_RESPONSE,
      `upload recording failed: HTTP ${res.status} ${(body && body.errmsg) || parsed.text.slice(0, 120)}`
    )
  }
  return { mp3Url: body.data.mp3Path || '', xmlUrl: body.data.xmlPath || '' }
}
